import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';

LP.dlgMailJob = {
  isSimple: false,

  prepare: function (selector, params) {
    $(selector).click(function () {
      LP.dlgMailJob.isSimple = false;
      if (!$(this).is('[disabled]')) {
        LP.Dialog.open(
          $.extend(params, {
            name: 'mailingjob',
            ajax: $(this).attr('url'),
            request: $(this).attr('url_params'),
            title: this.title,
            sizeable: true,
            width: 850,
            height: 650,
            beforeSubmit: LP.dlgMailJob.onSave,
            onLoad: LP.dlgMailJob.onLoad,
          })
        );
      }
      return false;
    });
  },

    onLoad: function () {
        $('.reminderDate').each(function (index) {
            LP.dlgMailJob.enableReminder(index, false);
            $('#rmdCheck_' + index).click(function () {
                LP.dlgMailJob.enableReminder(index, $(this).is(':checked'));
            });
        });

    $('#email_select').change(function () {
      LP.dlgMailJob.reloadPreview();
    });

    if ($('#email_select').length > 0) {
      LP.dlgMailJob.reloadPreview();
    }

    // $('#toggle_email_preview').click(function() {
    // 	var content = $('#email-template-preview');
    // 	if (content.is(':visible')) {
    // 		content.hide();
    // 	}
    // 	else {
    // 		content.show();
    // 		LP.dlgMailJob.reloadPreview();
    // 	}
    // });

    $('#showMailTime').click(function () {
      $('#inviteTimeTable').toggle();
    });

    $('#showReminder').click(function () {
      var reminderTable = $('#reminderTable');
      reminderTable.toggle();
      if (!reminderTable.is(':visible')) {
        $('input[type="checkbox"]', reminderTable).prop('checked', false);
        LP.dlgMailJob.enableReminder(0, false);
        LP.dlgMailJob.enableReminder(1, false);
        LP.dlgMailJob.enableReminder(2, false);
      }
    });
    LP.dlgMailJob.initReactDatePickerInputs();
  },
  initReactDatePickerInputs: function () {
    const datePickerDivs = document.querySelectorAll('.react-datepicker');
    Array.from(datePickerDivs).forEach((datePickerDiv) => {
      if (!datePickerDiv.getAttribute('data-init')) {
        window.reactPortals.addReactDatePickerField(datePickerDiv);
        datePickerDiv.setAttribute('data-init', true);
      }
    });
  },
  onSave: function () {
    var onSendingConfirm = function () {
      var texts = {
        de: 'Speichere Mailing-Auftrag, bitte warten...',
        en: 'Save mailing order, please wait...',
        es: 'Guarde el pedido de envío, por favor espere...',
        fr: 'Enregistrer la commande de publipostage, veuillez patienter...',
        nl: 'Postwissel opslaan, even wachten...',
        pt: 'Guardar encomenda por correio, por favor aguarde...',
        sv: 'Spara postorder, vänligen vänta...',
        bg: 'Запазване на пощенската поръчка, моля, изчакайте...',
      };
      var loaderText = texts[LP.getLanguage()] || texts['en'];
      var loaderTextDiv = '<div>' + loaderText + '</div>';

      var mailingjob = $('#mailingjob');
      $('.dialog_content', mailingjob).timedLoader({timeout: 1, text: loaderTextDiv});
      $('#dialog_content_div', mailingjob).hide();

      LP.Dialog.executeSubmit(null, LP.dlgMailJob.onError);
    };

    var onNoticeConfirm = function () {
      var confirmText = $('#mailjob_confirm_text').html();

      if ($('#showMailTime').is(':checked')) {
        confirmText = $('#mailjob_confirm_delay_text').html();
      }

      if (confirmText) {
        LP.UI.confirm(confirmText, onSendingConfirm);
      } else {
        onSendingConfirm();
      }
    };

    var onWarningConfirm = function () {
      var validateURL = 'backend/validateMailJob/';
      var validateData = $('#mailingJob').serialize() + '&poll=' + $('#pollId').val();
      window.Browser.send(
        validateURL,
        validateData,
        function (json) {
          if (json.needConfirm) {
            LP.UI.confirm(json.confirmText, onNoticeConfirm);
          } else {
            onNoticeConfirm();
          }
        },
        function (json) {
          var errorMsg = json.errors.join('<br/>');
          UI.showMsgBox(errorMsg);
          return true;
        }
      );
    };

    var warning = $('#mailjob_warning_text').html();
    if (warning) {
      return LP.UI.confirm(warning, onWarningConfirm);
    } else {
      onWarningConfirm();
    }

    return false;
  },

  onError: function () {
    var mailingjob = $('#mailingjob');
    $('#dialog_content_div', mailingjob).show();
    $('#loadertext', mailingjob).remove();
  },

  reloadPreview: function () {
    var url = 'backend/getEmailPreview/';
    var params = 'poll=' + $('#pollId').val() + '&email=' + $('#email_select').val();
    if ($('#mailserver_select').length > 0) params += '&server=' + $('#mailserver_select').val();
    var preview = $('#email-template-preview');
    preview.html('');
    window.Browser.loadHTML(preview, url, params);
  },
  enableReminder: function (index, enable) {
    $('.reminder_job_' + index).each(function (index, td) {
      $(td).css('color', enable ? '' : 'grey');
      if (enable) {
        $('select', td).removeAttr('disabled');
        $('input', td).removeAttr('disabled');
      } else {
        $('select', td).attr('disabled', '1');
        $('input', td).attr('disabled', '1');
      }
    });
  },
};
